import { render, staticRenderFns } from "./editSti01Dialog.vue?vue&type=template&id=048bcd72&scoped=true"
import script from "./editSti01Dialog.vue?vue&type=script&lang=js"
export * from "./editSti01Dialog.vue?vue&type=script&lang=js"
import style0 from "./editSti01Dialog.vue?vue&type=style&index=0&id=048bcd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048bcd72",
  null
  
)

export default component.exports